<template>
    <!-- Consistent and Clean Footer -->

    <!-- Enhanced eCommerce-style Footer -->
    <footer class="bg-green-800 text-white mt-0 text-sm md:text-base font-light">
        <div
            v-if="!cmsView"
            class="container mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10"
        >
            <div>
                <h5 class="text-lg md:text-xl font-extrabold uppercase mb-4 tracking-wide font-display">Company</h5>
                <ul class="space-y-2 text-gray-200">
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >About Us</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Careers</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Press</a
                        >
                    </li>
                </ul>
            </div>

            <div>
                <h5 class="text-lg md:text-xl font-extrabold uppercase mb-4 tracking-wide font-display">
                    Customer Care
                </h5>
                <ul class="space-y-2 text-gray-200">
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Help Center</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Returns & Refunds</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Shipping Info</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Track Order</a
                        >
                    </li>
                </ul>
            </div>

            <div>
                <h5 class="text-lg md:text-xl font-extrabold uppercase mb-4 tracking-wide font-display">Quick Links</h5>
                <ul class="space-y-2 text-gray-200">
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Wholesale</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Categories</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Top Brands</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Cash on Delivery</a
                        >
                    </li>
                </ul>
            </div>

            <div>
                <h5 class="text-lg md:text-xl font-extrabold uppercase mb-4 tracking-wide font-display">Legal</h5>
                <ul class="space-y-2 text-gray-200">
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Privacy Policy</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Terms & Conditions</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="hover:underline"
                            >Cookie Policy</a
                        >
                    </li>
                </ul>
            </div>

            <div>
                <h5 class="text-lg md:text-xl font-extrabold uppercase mb-4 tracking-wide font-display">Contact</h5>
                <ul class="space-y-2 text-gray-200">
                    <li class="flex items-start gap-2">Diamond Village, San-Fernando</li>
                    <li class="flex items-start gap-2">+1 (868) 340-3081</li>
                    <li class="flex items-start gap-2">support@humtt.com</li>
                </ul>
            </div>
        </div>

        <div class="container-footer mx-auto px-6 py-4 border-t border-green-700 bg-gray-900">
            <div class="flex flex-col md:flex-row justify-between items-center text-xs md:text-sm text-gray-300">
                <p class="mb-2 md:mb-0">© {{ new Date().getFullYear() }}, Humtt.com. All rights reserved.</p>
                <div class="flex items-center space-x-3 mb-2 md:mb-0">
                    <span>Secure Payments:</span>
                    <CODIcon class="flex-shrink-0 w-6 h-6 mr-2" />
                    <MasterCardIcon class="flex-shrink-0 w-6 h-6 mr-2" />
                    <!-- <img
                        src="/storage/images/payment-mastercard.svg"
                        alt="MasterCard"
                        class="h-5"
                    />
                    <img
                        src="/storage/images/payment-cod.svg"
                        alt="Cash on Delivery"
                        class="h-5"
                    /> -->
                </div>
                <p>
                    Developed by
                    <a
                        href="http://softwebdevelopers.com/"
                        class="underline"
                        target="_blank"
                        >Softweb Developers</a
                    >
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
    import CODIcon from '@/Components/Icons/CODIcon';
    import MasterCardIcon from '@/Components/Icons/MasterCardIcon';
    // import TwitterIcon from '../Components/Icons/TwitterIcon';
    // import LocationIcon from '../Components/Icons/LocationIcon';
    // import MailIcon from '../Components/Icons/MailIcon';
    // import TelephoneIcon from '../Components/Icons/TelephoneIcon';

    export default {
        name: 'Footer',

        components: {
            CODIcon,
            MasterCardIcon,
        },

        computed: {
            currentYear() {
                return new Date().getFullYear();
            },
        },
    };
</script>

<!-- <style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@500;700;800&display=swap');

    .font-display {
        font-family: 'Manrope', sans-serif;
    }
</style> -->
